export default __webpack_public_path__ + "static/media/flickr-photo-search.7557edb0.png";